import { FtIn } from './ft-in.js';
export const DIMENSION_LABELS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'O', 'R'];
// --- Factory Functions ---
export function createEstimateDefaults(overrides) {
    return {
        sizeUnit: 'imperial',
        weightUnit: 'pounds',
        buildingCode: 'ACI 318-19',
        concreteStrength: 4000,
        rebarGrade: 60,
        plainGrade: 60,
        rebarCoating: 'black',
        plainCoating: 'black',
        estimatingLap: '40D',
        tieClearance: FtIn.parse('0-012'),
        spiralClearance: FtIn.parse('0-03'),
        spacingTolerance: FtIn.zero(),
        softHooks: false,
        seismicHooks: false,
        stockBarLength: FtIn.parse('40-00'),
        wasteFactor: 0.02,
        minBarLength: FtIn.parse('2-00'),
        lapTable: '',
        steelManufacturedIn: 'ANY',
        stockBarExtensionLaps: 1,
        ...overrides,
    };
}
export function createBackground(overrides) {
    return {
        locations: {
            estimating: null,
            detailing: null,
            fabricating: null,
            sales: null,
            det: null,
            ...(overrides?.locations ?? {}),
        },
        people: {
            estimator: '',
            detailer: '',
            salesperson: '',
            ...(overrides?.people ?? {}),
        },
    };
}
export function createJob(overrides) {
    return {
        customer: '',
        architect: '',
        engineer: '',
        background: createBackground(),
        jobType: 'lump_sum',
        status: 'incomplete',
        creationDate: new Date().toISOString().slice(0, 10),
        lastModified: new Date().toISOString().slice(0, 10),
        escalation: false,
        pipelineJobId: null,
        source: 'manual_entry',
        extractionConfidence: null,
        bidDate: null,
        generalContractor: null,
        version: 1,
        defaults: createEstimateDefaults(),
        segments: [],
        barMarks: [],
        subsetQueries: [],
        notes: [],
        ...overrides,
    };
}
export function createSegment(overrides) {
    return {
        parentSegmentId: null,
        costingIncluded: true,
        rebarWeight: 0,
        plainWeight: 0,
        miscWeight: 0,
        totalWeight: 0,
        sortOrder: 0,
        elementType: null,
        alternateBid: false,
        extractionSourceId: null,
        lines: [],
        ...overrides,
    };
}
export function createLine(overrides) {
    return {
        material: 'TR',
        placing: '',
        grade: null,
        quantity: 0,
        span: null,
        spacing: null,
        multiplier: 1,
        size: null,
        class: 'S',
        L1: null,
        L2: null,
        L3: null,
        L4: null,
        L5: null,
        lap: null,
        stockLength: null,
        weightLbs: 0,
        notes: '',
        barMark: null,
        confidence: null,
        flags: [],
        override: false,
        overrideReason: null,
        derivedFrom: null,
        meshSheet: null,
        tags: [],
        ...overrides,
    };
}
